import { Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import AppModal from "components/common/AppModal";
import { ClubFormController } from "components/Forms/ClubForm";
import ModalFormRenderer from "components/Forms/FormRenderers/ModalFormRenderer";
import { AppController } from "controllers/AppController";
import { injectModal } from "lib/injectParams";

const ClubForm = ClubFormController.scope(
  ApplicationView(() => {
    const controller = ClubFormController.use();
    const { loading } = controller.state;

    if (loading) {
      return (
        <div className="flex items-center justify-center">
          <Spinner size={64} />
        </div>
      );
    }
    const fields = Object.values(controller.fields()).filter((field) => field.group === "basic");
    return <ModalFormRenderer name="club" fields={fields} />;
  }),
);

/**
 * Model component for creating a club
 */
const NewClub: React.FC = () => {
  const controller = AppController.use();

  return (
    <AppModal title="New club">
      <ClubForm
        attributes={{}}
        onSubmit={async (record) => {
          await controller.actionSetCurrentClub(record, false);
          controller.actionCloseModal();
        }}
      />
    </AppModal>
  );
};

export default injectModal(ApplicationView(NewClub));
